import { isExisty, isNonEmptyArray } from 'utils/helpers.util';

import { ICartState } from 'pages/Cart/redux/reducer';
import useCart from 'pages/Cart/hooks/cart';
import useShipments from 'services/shipments/hooks/useShipments.hook';
import { IShipmentsHook } from 'services/shipments/types/shipments.types';
import { useDispatch, useSelector } from 'react-redux';
import { IAppState } from 'config/redux/reducers';
import useIsExpressCheckout from 'pages/Checkout/hooks/useIsExpressCheckout';
import { useCallback, useEffect } from 'react';
import { expressCartAction } from 'pages/Cart/redux/actions/getCart.action';
import { hidePageLoader, showPageLoader } from 'common/PageLoader/redux/pageLoader.action';

const useCartShipments = (
  shouldFetch = true
): {
  cartState: ICartState;
  shipmentsState: IShipmentsHook;
  isCartAPICompleted: boolean;
  isLoading: boolean;
  isCartEmpty: boolean;
  isExpressCheckout: boolean;
  createExpressCart: (successCallback?: () => void) => void;
} => {
  const dispatch = useDispatch();
  const isExpressCheckout = useIsExpressCheckout();
  const { areaCode } = useSelector(({ appConfig }: IAppState) => appConfig);
  const cartState = useCart(shouldFetch && !!areaCode);
  const shipmentsState = useShipments();
  const isCartAPICompleted = shipmentsState.isLoadedOnce;
  const isErrorExists = isExisty(cartState.error);
  const isLoading = cartState.loading || (!isCartAPICompleted && !isErrorExists);
  const isCartEmpty = isCartAPICompleted && !isNonEmptyArray(shipmentsState.shipments as any[]);

  const createExpressCart = useCallback(
    (successCallback?: () => void) => {
      dispatch(showPageLoader());
      if (!!areaCode) {
        dispatch(
          expressCartAction(
            () => {
              dispatch(hidePageLoader());
              if (successCallback) {
                successCallback();
              }
            },
            () => dispatch(hidePageLoader())
          )
        );
      }
    },
    [dispatch, areaCode]
  );

  useEffect(() => {
    if (isExpressCheckout && !cartState.cartData.code) {
      createExpressCart();
    }
  }, [isExpressCheckout, cartState.cartData, createExpressCart]);

  return {
    cartState,
    shipmentsState,
    isCartAPICompleted,
    isLoading,
    isCartEmpty,
    isExpressCheckout,
    createExpressCart,
  };
};

export default useCartShipments;
